<fieldset>
  <form-radio-group [formGroup]="formGroup" [options]="mapToValueAndLabel(options)" groupName="dietary-needs" [style]="'chip'" orientation="horizontal" [defaultValue]="value"></form-radio-group>
</fieldset>